import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPhone, FiMail, FiMenu, FiX } from 'react-icons/fi';
import styles from './Navbar.module.css';

const links = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#whyus' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Top bar */}
      <div className={styles.topBar}>
        <div className={styles.topBarInner}>
          <a href="tel:+17789912001" className={styles.topContact}>
            <FiPhone size={12} /> (778) 991-2001
          </a>
          <span className={styles.topDivider}>|</span>
          <a href="mailto:aussiespec.structures@gmail.com" className={styles.topContact}>
            <FiMail size={12} /> aussiespec.structures@gmail.com
          </a>
          <span className={styles.topRight}>Incorporation No: BC1585120</span>
        </div>
      </div>

      <motion.nav
        className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
      >
        <a href="#hero" className={styles.logo} onClick={e => go(e, '#hero')}>
          <div className={styles.logoMark}>
            <span>AS</span>
          </div>
          <div className={styles.logoText}>
            <span className={styles.logoMain}>AussieSpec</span>
            <span className={styles.logoSub}>Structures</span>
          </div>
        </a>

        <ul className={styles.links}>
          {links.map(l => (
            <li key={l.label}>
              <a href={l.href} className={styles.link} onClick={e => go(e, l.href)}>
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a href="#contact" className={styles.ctaBtn} onClick={e => go(e, '#contact')}>
          Get a Free Quote
        </a>

        <button className={styles.hamburger} onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div
            className={styles.mobile}
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
          >
            <ul className={styles.mobileLinks}>
              {links.map((l, i) => (
                <motion.li key={l.label}
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.07 * i }}
                >
                  <a href={l.href} onClick={e => go(e, l.href)}>{l.label}</a>
                </motion.li>
              ))}
              <motion.li initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }}>
                <a href="#contact" className={styles.mobileCta} onClick={e => go(e, '#contact')}>
                  Get a Free Quote
                </a>
              </motion.li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
